let collator: Intl.Collator = null;
let collatorLocale: string = null;

export function getIntlCollator(locale: string): Intl.Collator {
  const isSameLocale = locale === collatorLocale;
  if (isSameLocale && collator != null) {
    return collator;
  }

  collator = new Intl.Collator(locale, { ignorePunctuation: true, sensitivity: `base`, usage: `sort` });
  collatorLocale = locale;
  return collator;
}

let currencyFormat: Intl.NumberFormat = null;
let currencyLocale: string = null;
let intlCurrency: string = null;

export function getCurrencyFormatter(locale: string, currency: string): Intl.NumberFormat {
  const isSameLocale = locale === currencyLocale;
  const isSameCurrency = currency === intlCurrency;

  if (isSameLocale && isSameCurrency && currencyFormat != null) {
    return currencyFormat;
  }

  currencyFormat = new Intl.NumberFormat(locale, {
    style: `currency`,
    currency: currency ?? `EUR`,
    useGrouping: true,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });

  currencyLocale = locale;
  intlCurrency = currency;
  return currencyFormat;
}

let numberFormat: Intl.NumberFormat = null;
let numberLocale: string = null;
let lastUseGrouping: boolean = null;
const lastMinimumFractionDigits: number = undefined;

export function getNumberFormatter(
  locale: string,
  useGrouping = true,
  minimumFractionDigits = undefined
): Intl.NumberFormat {
  const isSameLocale = locale === numberLocale;
  const isSameLastGrouping = lastUseGrouping === useGrouping;
  const isSameMinimumFractionDigit = lastMinimumFractionDigits === minimumFractionDigits;
  if (isSameLocale && isSameLastGrouping && isSameMinimumFractionDigit && numberFormat != null) {
    return numberFormat;
  }

  numberFormat = new Intl.NumberFormat(locale, {
    style: `decimal`,
    useGrouping,
    minimumFractionDigits
  });

  numberLocale = locale;
  lastUseGrouping = useGrouping;
  return numberFormat;
}

export type DateTimeStyle = "short" | "full" | "long" | "medium";

let dateTimeFormat: Intl.DateTimeFormat = null;
let dateTimeLocale: string = null;
let lastDateStyle: DateTimeStyle = null;
let lastTimeStyle: DateTimeStyle = null;

export function getDateTimeFormatter(
  locale: string,
  dateStyle: DateTimeStyle = `medium`,
  timeStyle: DateTimeStyle = `short`
): Intl.DateTimeFormat {
  const isSameLocale = locale === dateTimeLocale;
  const isSameDateStyle = lastDateStyle === dateStyle;
  const isSameTimeStyle = lastTimeStyle === timeStyle;

  if (isSameLocale && isSameDateStyle && isSameTimeStyle && dateTimeFormat != null) {
    return dateTimeFormat;
  }

  dateTimeFormat = new Intl.DateTimeFormat(locale, { dateStyle, timeStyle: timeStyle == null ? undefined : timeStyle });

  dateTimeLocale = locale;
  lastDateStyle = dateStyle;
  lastTimeStyle = timeStyle;
  return dateTimeFormat;
}

let relativeTimeFormat: Intl.RelativeTimeFormat = null;
let relativeTimeLocale: string = null;

export function getRelativeTimeFormatter(locale: string): Intl.RelativeTimeFormat {
  const isSameLocale = locale === relativeTimeLocale;

  if (isSameLocale && dateTimeFormat != null) {
    return relativeTimeFormat;
  }

  relativeTimeFormat = new Intl.RelativeTimeFormat(locale, {
    numeric: `auto`,
    style: `long`
  });

  relativeTimeLocale = locale;
  return relativeTimeFormat;
}
